<template>
    <div class="mt-5 form-material">
        <h3>Image Update</h3>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="serviceId">Service</label>
                    <input type="text" class="form-control" id="serviceId" v-model="serviceId">
                </div>
                <button @click="updateImageService" :disabled="uploading" class="btn btn-primary mr-2">Sync</button>
                <button @click="listServiceImages" :disabled="loading" class="btn btn-info">List</button>
                <div v-if="serviceImages.length" class="mt-3">
                    <h5>Imágenes encontradas: {{ serviceImages.length }}</h5>
                    <ul class="list-group">
                        <li v-for="img in serviceImages" :key="img.key" class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <img v-if="img.src" :src="img.src" class="mr-2" style="max-width: 80px; max-height: 60px; object-fit: cover;">
                                <span>{{ img.key }}</span>
                            </div>
                            <button @click="deleteImage(img.key, 'service')" class="btn btn-sm btn-danger">Eliminar</button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="hotelId">Hotel</label>
                    <input type="text" class="form-control" id="hotelId" v-model="hotelId">
                </div>
                <button @click="updateImageHotel" :disabled="uploading" class="btn btn-primary mr-2">Sync</button>
                <button @click="listHotelImages" :disabled="loading" class="btn btn-info">List</button>
                <div v-if="hotelImages.length" class="mt-3">
                    <h5>Imágenes encontradas: {{ hotelImages.length }}</h5>
                    <ul class="list-group">
                        <li v-for="img in hotelImages" :key="img.key" class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <img v-if="img.src" :src="img.src" class="mr-2" style="max-width: 80px; max-height: 60px; object-fit: cover;">
                                <span>{{ img.key }}</span>
                            </div>
                            <button @click="deleteImage(img.key, 'hotel')" class="btn btn-sm btn-danger">Eliminar</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  const api = window.api;
  
  export default {
    name: "ImageUpdate",
    data() {
      return {
        serviceId: null,
        hotelId: null,
        uploading: false,
        loading: false,
        serviceImages: [],
        hotelImages: [],
      };
    },
    methods: {
      async updateImageService() {
        this.uploading = true;
        let res = await api.post("/api/tpsql/sync_images_service/", JSON.stringify({serviceId: this.serviceId}), {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, (err) => { 
          this.$root.$refs.index.showNotification(err, 'danger')
          this.uploading = false;
        });
        if (res) {
          alert("Image updated");
          this.uploading = false;
        }
      },
      async updateImageHotel() {
        this.uploading = true;
        let res = await api.post("/api/tpsql/sync_images_hotel/", JSON.stringify({hotelId: this.hotelId}), {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, (err) => { 
          this.$root.$refs.index.showNotification(err, 'danger')
          this.uploading = false;
        });
        if (res) {
          alert("Image updated");
          this.uploading = false;
        }
      },
      async listServiceImages() {
        if (!this.serviceId) return;
        this.loading = true;
        this.serviceImages = [];
        try {
          let res = await api.get(`/api/tpsql/list_service_images?serviceId=${this.serviceId}`);
          if (res) this.serviceImages = res;
        } catch(err) {
          this.$root.$refs.index.showNotification(err, 'danger');
        }
        this.loading = false;
      },
      async listHotelImages() {
        if (!this.hotelId) return;
        this.loading = true;
        this.hotelImages = [];
        try {
          let res = await api.get(`/api/tpsql/list_hotel_images?hotelId=${this.hotelId}`);
          if (res) this.hotelImages = res;
        } catch(err) {
          this.$root.$refs.index.showNotification(err, 'danger');
        }
        this.loading = false;
      },
      async deleteImage(key, type) {
        if (!confirm(`Eliminar ${key}?`)) return;
        this.loading = true;
        try {
          let res = await api.remove(`/api/tpsql/delete_image?key=${encodeURIComponent(key)}`);
          if (res) {
            if (type === 'service') {
              this.serviceImages = this.serviceImages.filter(img => img.key !== key);
            } else {
              this.hotelImages = this.hotelImages.filter(img => img.key !== key);
            }
          }
        } catch(err) {
          this.$root.$refs.index.showNotification(err, 'danger');
        }
        this.loading = false;
      },
    },
  };
  </script>
